const Landing = () =>
  import(
    /* webpackChunkName: "site-landing" */ '@/pages/site-generator/cms/landing/index.vue'
  )
const CreateLanding = () =>
  import(
    /* webpackChunkName: "site-landing" */ '@/pages/site-generator/cms/landing/create.vue'
  )
const EditLanding = () =>
  import(
    /* webpackChunkName: "site-landing" */ '@/pages/site-generator/cms/landing/edit.vue'
  )

export default {
  path: 'landing',
  meta: {
    label: 'landingPage',
    auth: 'landing'
  },
  component: {
    name: 'Landing',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SiteLandingReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Landing
    },
    {
      name: 'SiteCreateLanding',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateLanding
    },
    {
      name: 'SiteEditLanding',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditLanding,
      props: true
    }
  ]
}
